import styled from 'styled-components';

export default styled.div`
  margin-top: 2rem;

  p:last-child {
    margin: 0;
  }
`;
